<div [style.width.px]="width">
  <ap-combobox
    #combo
    [list]="items()"
    selectType="single"
    [placeholder]="label"
    [optionName]="keyProp"
    [optionValue]="valueProp"
    [disabled]="!!disabled"
    [required]="!!required"
    [(ngModel)]="value"
    (ngModelChange)="valueChangeHandler($event)"
    (onSelect)="selectItemHandler($event)"
    (onFilterResult)="filterResult($event)">
    @for (item of items(); track item) {
      <ap-dropdown-list-item
        [item]="item"
        [optionName]="keyProp"
        [optionValue]="valueProp"
        [highlightText]="highlightText">
      </ap-dropdown-list-item>
    }
  </ap-combobox>
</div>
